import {
	AbstractControl,
	NG_VALIDATORS,
	ValidationErrors,
	Validator,
} from '@angular/forms';
import {
	Directive,
	Input,
} from '@angular/core';
import {
	get,
	isString,
} from 'lodash';

@Directive({
	selector: '[commonMinlength]',
	providers: [
		{
			provide: NG_VALIDATORS,
			useExisting: CommonMinlengthValidatorDirective,
			multi: true,
		},
	],
})
export class CommonMinlengthValidatorDirective implements Validator {
	@Input() commonMinlength: number | string;
	@Input() commonMinLengthRequired = true;

	validate (control: AbstractControl): ValidationErrors | null {
		const length = get(control, 'value.length', null);
		const minLengths = this.parseLength(this.commonMinlength);

		if (!this.commonMinLengthRequired && (length === null || length === 0)) {
			return null;
		}

		return this.hasError(minLengths, length) ? { minLength: true } : null;
	}

	hasError (minLengths: number[], length: number): boolean {
		return minLengths.some((current, index) => {
			const prev = minLengths[index - 1] || null;
			const inPrevRange = prev ? length <= prev : false;

			return !inPrevRange && length < current;
		});
	}

	parseLength (minLength: number | string): number[] {
		if (isString(minLength)) {
			return minLength.split('|').map((item) => parseInt(item) || 0);
		}
		return [minLength];
	}
}
